import {useState, useRef} from 'react';
import {DatePicker, Row, Col} from 'antd';
import {toFSDate} from "../../util/timeutils";
import * as dayjs from 'dayjs'

export const DatePickerWidget = ({date, placeholder, onChange, disabled, minDate, maxDate, children, props}) => {
    const [active, setActive] = useState(false);
    const [isOpen, setIsOpen]  = useState(false);

    const onClick = () => {
        if (disabled === true) {
            // disabled pickers can not be changed
            return;
        }
        setActive(true);
        // use a timer here to allow time for the DatePicker to mount and allow the ref to become valid
        setTimeout(() => {
            inputRef.current.focus();
        }, 20);
    }

    const inputRef = useRef(null);

    const onDateChange = (date, dateString) => {
        if (onChange) {
            onChange(dateString, date);
        }
        setActive(false);
    }


    const onBlur = () => {
        if (isOpen === false && active === true) {
            setTimeout(() => {
                setActive(false);
            }, 200);
        }
    }

    const onOpenChange = (open) => {
        setIsOpen(open);
        if (open === false) {
            setActive(false);
        }
    }

    let dateContent;
    if (date) {
        dateContent = toFSDate(new Date(date));
    } else {
        dateContent = `${placeholder}`
    }

    const minDateJS = (minDate !== undefined) ? dayjs(minDate) : undefined;
    const maxDateJS = (maxDate !== undefined) ? dayjs(maxDate) : undefined;

    if (active) {
        return <DatePicker placeholder={placeholder} onChange={onDateChange}  onBlur={onBlur} onOpenChange={onOpenChange} ref={inputRef} minDate={minDateJS} maxDate={maxDateJS}/>;
    } else {
        return <div style={{cursor: "pointer", color: "#108ee9", marginTop: '5px'}} onClick={onClick}>
            <Row>
                <Col style={{marginRight: '5px'}}>
                    {dateContent}
                </Col>
                <Col>
                    {children}
                </Col>
            </Row>

        </div>
    }
}